'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toMomentUTC = exports.toMomentPortalTz = exports.toMoment = exports.EmptySimpleDateRecord = exports.SimpleDateRecord = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.equals = equals;
exports.compare = compare;
exports.make = make;
exports.fromMoment = fromMoment;
exports.fromPickadate = fromPickadate;
exports.toArray = toArray;
exports.isValid = isValid;
exports.isValidRange = isValidRange;
exports.now = now;
exports.makeMoment = makeMoment;
exports.startOfThis = startOfThis;
exports.startOfPrior = startOfPrior;
exports.endOfPrior = endOfPrior;
exports.daysAgo = daysAgo;
exports.beginningOfTime = beginningOfTime;
exports.maxDate = maxDate;
exports.minDate = minDate;

var _underscore = require('../utils/underscore');

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _immutable = require('immutable');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SimpleDateRecord = exports.SimpleDateRecord = (0, _immutable.Record)({
  year: NaN,
  month: NaN,
  date: NaN
}, 'SimpleDateRecord');

var EmptySimpleDateRecord = exports.EmptySimpleDateRecord = SimpleDateRecord();

/**
 * Test if two SimpleDate objects represent the same date.
 *
 * @param  {?SimpleDateRecord}
 * @param  {?SimpleDateRecord}
 * @return {bool}
 */
function equals(dateA, dateB) {
  if (dateA === dateB) {
    return true;
  }
  if (!dateA || !dateB) {
    return false;
  }
  return dateA.year === dateB.year && dateA.month === dateB.month && dateA.date === dateB.date;
}

/**
 * Test which of two SimpleDate objects represents an earlier date, for sorting. E.g.:
 *
 * [dateA, dateB, dateC].sort(compare)
 *
 * @param  {?SimpleDateRecord}
 * @param  {?SimpleDateRecord}
 * @return {int}
 */
function compare(dateA, dateB) {
  var keys = ['year', 'month', 'date'];
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (dateA[key] < dateB[key]) {
      return -1;
    } else if (dateA[key] > dateB[key]) {
      return 1;
    }
  }
  return 0;
}

function make(year, month, date) {
  return EmptySimpleDateRecord.merge({ year: year, month: month, date: date });
}

/**
 * @param  {Moment}
 * @return {SimpleDateRecord}
 */
function fromMoment(moment) {
  if (!moment.isValid()) {
    return EmptySimpleDateRecord;
  }
  return make(moment.get('year'), moment.get('month'), moment.get('date'));
}

/**
 * Converts a pickadate "select" object to a simple date object
 *
 * @param  {Object}
 * @return {SimpleDateRecord}
 */
function fromPickadate(_ref) {
  var year = _ref.year,
      month = _ref.month,
      date = _ref.date;

  return make(year, month, date);
}

/**
 * Converts a simple date to an array of the form [year, month, date]
 *
 * @param  {SimpleDateRecord}
 * @return {Array}
 */
function toArray(simpleDate) {
  if (simpleDate == null) {
    return null;
  }
  var year = simpleDate.year,
      month = simpleDate.month,
      date = simpleDate.date;

  return [year, month, date];
}

/**
 * Returns true if a simple date object contains valid data
 *
 * @param  {SimpleDateRecord}
 * @return {bool}
 */
function isValid(simpleDate) {
  if (simpleDate == null) {
    return false;
  }
  var year = simpleDate.year,
      month = simpleDate.month,
      date = simpleDate.date;


  return typeof year === 'number' && typeof month === 'number' && typeof date === 'number' && _I18n2.default.moment([year, month, date]).isValid();
}

/**
 * Returns true if given object contains a valid start and end date and
 * the start date is before or equal to the end date
 *
 * @param  {Object}
 * @return {bool}
 */
function isValidRange(_ref2) {
  var startDate = _ref2.startDate,
      endDate = _ref2.endDate;

  return isValid(startDate) && isValid(endDate) && !_I18n2.default.moment(toArray(endDate)).isBefore(_I18n2.default.moment(toArray(startDate)));
}

/**
 * Returns a simple date representing the date right now.
 * Analogous to Date.now().
 *
 * @param  {string}     "portalTz", "userTz", or "utc"
 * @return {SimpleDateRecord}
 */
function now() {
  var constructor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'userTz';

  var momentNow = _I18n2.default.moment[constructor]();
  return make(momentNow.year(), momentNow.month(), momentNow.date());
}

/**
 * Function for converting a SimpleDateRecord to a Moment
 *
 * @param  {string}     "portalTz", "userTz", or "utc"
 * @param  {SimpleDateRecord}
 * @return {Moment}
 */
function makeMoment(constructor, simpleDate) {
  return _I18n2.default.moment[constructor](toArray(simpleDate));
}

/**
 * Converts a simple date to a Moment object in the user's timezone.
 * Useful for getting to other date representations. e.g.
 *
 * const timestamp = toMoment(date).valueOf();
 * const formattedStr = toMoment(date).format('L');
 *
 * @param  {SimpleDateRecord}
 * @return {Moment}
 */
var toMoment = exports.toMoment = (0, _underscore.partial)(makeMoment, 'userTz');

/**
 * Like `toMoment`, but returns a Moment in the portal timezone
 * rather than the user's timezone.
 *
 * @param  {SimpleDateRecord}
 * @return {Moment}
 */
var toMomentPortalTz = exports.toMomentPortalTz = (0, _underscore.partial)(makeMoment, 'portalTz');

/**
 * Like `toMoment`, but returns a Moment in UTC rather than the
 * user's timezone.
 *
 * @param  {SimpleDateRecord}
 * @return {Moment}
 */
var toMomentUTC = exports.toMomentUTC = (0, _underscore.partial)(makeMoment, 'utc');

/**
 * Returns a simple date representing the date at the start of
 * the given period
 *
 * @param {string}
 * @param {string}     "portalTz", "userTz", or "utc"
 * @return {SimpleDateRecord}
 */
function startOfThis(period) {
  var constructor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'userTz';

  return fromMoment(_I18n2.default.moment[constructor]().startOf(period));
}

/**
 * Returns a simple date representing the date at the start of
 * the period a given number of periods ago
 *
 * @param {string}
 * @param {integer}
 * @return {SimpleDateRecord}
 */
function startOfPrior(period) {
  var periodsAgo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var constructor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'userTz';

  return fromMoment(_I18n2.default.moment[constructor]().subtract(periodsAgo, period).startOf(period));
}

/**
 * Returns a simple date representing the date at the end of
 * the period a given number of periods ago
 *
 * @param {string}
 * @param {integer}
 * @param {string}     "portalTz", "userTz", or "utc"
 * @return {SimpleDateRecord}
 */
function endOfPrior(period) {
  var periodsAgo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var constructor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'userTz';

  return fromMoment(_I18n2.default.moment[constructor]().subtract(periodsAgo, period).endOf(period));
}

/**
 * Returns a simple date representing the date the given number of days
 * before today
 *
 * @param {number}
 * @param {string}     "portalTz", "userTz", or "utc"
 * @return {SimpleDateRecord}
 */
function daysAgo(numDays) {
  var constructor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'userTz';

  return fromMoment(_I18n2.default.moment[constructor]().subtract(numDays, 'days'));
}

/**
 * Returns a simple date representing Jan 1, 2000, a date that should be
 * before any other HubSpot related date
 *
 * @return {SimpleDateRecord}
 */
function beginningOfTime() {
  return make(2000, 0, 1);
}

/**
 * Returns the latest date in the given array of SimpleDate's
 *
 * @param  {Array[SimpleDateRecord]}
 * @return {SimpleDateRecord}
 */
function maxDate(dates) {
  if (!dates) return null;
  var compactedDates = dates.filter(Boolean);
  if (compactedDates.length === 0) return null;

  var result = (0, _underscore.max)(compactedDates, function (date) {
    return toMomentUTC(date).unix();
  });

  // If all given dates are invalid, max returns -Infinity
  if ((typeof result === 'undefined' ? 'undefined' : _typeof(result)) !== 'object') {
    return null;
  }

  return result;
}

/**
 * Returns the oldest date in the given array of SimpleDate's
 *
 * @param  {Array[SimpleDateRecord]}
 * @return {SimpleDateRecord}
 */
function minDate(dates) {
  if (!dates) return null;
  var compactedDates = dates.filter(Boolean);
  if (compactedDates.length === 0) return null;

  var result = (0, _underscore.min)(compactedDates, function (date) {
    return toMomentUTC(date).unix();
  });

  // If all given dates are invalid, max returns -Infinity
  if ((typeof result === 'undefined' ? 'undefined' : _typeof(result)) !== 'object') {
    return null;
  }

  return result;
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/core/SimpleDate.js
// module id = 212
// module chunks = 0